import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// Item B4: never a blank screen. Skeleton + friendly line after 4s + Retry / Report slow after 15s.
export const SLOW_LINES = [
  "Still fetching your chats… RM Desk is brand new and still learning to be quick. Thanks for bearing with us 🙂",
  "Almost there, pulling the latest from Airtable…",
  "Good things take a few seconds. We're making this faster every week.",
];

export function Skeleton({ rows = 3, className = "" }) {
  return (
    <div className={`animate-pulse space-y-2 ${className}`} data-testid="skeleton">
      {Array.from({ length: rows }).map((_, i) => <div key={i} className="h-4 rounded bg-[#E2E2E2]/70" style={{ width: `${90 - (i % 3) * 18}%` }} />)}
    </div>
  );
}

export function Loading({ label = "Loading…", onRetry, rows = 4, compact, section }) {
  const [secs, setSecs] = useState(0);
  const loc = useLocation();
  useEffect(() => { const t = setInterval(() => setSecs((s) => s + 1), 1000); return () => clearInterval(t); }, []);
  const line = secs >= 4 ? SLOW_LINES[Math.floor(secs / 5) % SLOW_LINES.length] : null;
  const reportSlow = async () => {
    try {
      await api.post("/feedback", { summary: `Slow load: ${section || loc.pathname} (${secs}s)`, details: `Page ${loc.pathname}${window.__truvaCaseId ? ` · case ${window.__truvaCaseId}` : ""} still loading after ${secs}s.`, priority: "P2 – annoying or slow", page: loc.pathname, case_id: window.__truvaCaseId || "", browser: navigator.userAgent });
      toast.success("Reported — thanks!");
    } catch { toast.error("Could not report"); }
  };
  return (
    <div className={`rounded-2xl border border-[#E2E2E2] bg-white shadow-sm ${compact ? "p-3" : "p-5"}`} data-testid="loading-state">
      <div className="flex items-center gap-2 text-[#6B7280] text-sm mb-3"><Loader2 className="w-4 h-4 animate-spin text-[#FF4802]" /> {label}</div>
      <Skeleton rows={rows} />
      {line && <p className="text-xs text-[#6B7280] mt-3" data-testid="loading-slow-line">{line}</p>}
      {secs >= 15 && (
        <div className="flex items-center gap-3 mt-2 text-xs" data-testid="loading-too-long">
          <span className="text-[#92600a]">This is taking longer than usual.</span>
          {onRetry && <button onClick={onRetry} data-testid="loading-retry" className="text-[#FF4802] font-medium hover:underline">Retry</button>}
          <button onClick={reportSlow} data-testid="loading-report-slow" className="text-[#6B7280] hover:underline">Report slow</button>
        </div>
      )}
    </div>
  );
}
